import { apiBaseUrl } from "./config"
import { genericFetch } from "./common-service"
import UrlSegments from "./constant/url-segment"
import { UserRequestBody } from "./request-body"
import { getBaseHeader } from "./utils"
import { User, Service } from "../../model"

const usersBaseUrl = `${apiBaseUrl}/${UrlSegments.USERS}`

export function createUser(user: UserRequestBody): Promise<User> {
	const init: RequestInit = {
		body: JSON.stringify(user),
		headers: getBaseHeader(true),
		method: "POST"
	}
	return genericFetch<User>(usersBaseUrl, init)
}

export function deleteUser(user: User): Promise<void> {
	const url = `${usersBaseUrl}/${user.id}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}
	return genericFetch<void>(url, init)
}

export function disableUser(user: User): Promise<User> {
	const url = `${usersBaseUrl}/${user.id}`
	const init: RequestInit = {
		body: JSON.stringify({ user: { enabled: false }}),
		headers: getBaseHeader(true),
		method: "PUT"
	}
	return genericFetch<User>(url, init)
}

export function enableUser(user: User): Promise<User> {
	const url = `${usersBaseUrl}/${user.id}`
	const init: RequestInit = {
		body: JSON.stringify({ user: { enabled: true }}),
		headers: getBaseHeader(true),
		method: "PUT"
	}
	return genericFetch<User>(url, init)
}

export function findUser(userId: number): Promise<User> {
	const url = `${usersBaseUrl}/${userId}`
	const init = { headers: getBaseHeader(true) }
	return genericFetch<User>(url, init)
}

export function findUsers(signal?: AbortSignal): Promise<User[]> {
	const init: RequestInit = {
		headers: getBaseHeader(),
		signal
	}
	return genericFetch<User[]>(usersBaseUrl, init)
}

export function findUserServices(
	user: User,
	signal: AbortSignal
): Promise<Service[]> {
	const url = `${usersBaseUrl}/${user.id}/services`
	const init: RequestInit = {
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		signal
	}

	return genericFetch<Service[]>(url, init)
}

export function resetPassword(user: User): Promise<void> {
	const url = `${usersBaseUrl}/${user.id}/password`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "PUT"
	}
	return genericFetch<void>(url, init)
}

export function updateUser(userId: number, user: UserRequestBody): Promise<User> {
	const url = `${usersBaseUrl}/${userId}`
	const init: RequestInit = {
		body: JSON.stringify(user),
		headers: getBaseHeader(true),
		method: "PUT"
	}
	return genericFetch<User>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/users-service-2.ts